<div
  id="contact-item-{{ contactIndex }}"
  class="grid-row grid-cols-2 lg:grid-cols-[2.5fr_2.5fr_2fr_3rem] lg:min-h-[4.2rem]"
>
  <div class="col-span-2 lg:col-span-1 flex items-center gap-2">
    <div class="flex items-center gap-2 min-w-0 flex-1">
      <div class="flex items-center justify-center w-9 h-9 rounded-full bg-grey-light-concrete text-grey-mid shrink-0">
        <ion-icon name="person" class="size-5"></ion-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <p class="font-medium text-sm text-grey-blue">{{ contactForm.controls['name'].value }}</p>
        @if (contactForm.controls['contact_position'].value) {
          <span class="text-grey-mid text-xs font-normal capitalize truncate">{{
            contactForm.controls['contact_position'].value
          }}</span>
        }
      </div>
    </div>

    <button
      type="button"
      id="edit-contact-mobile-{{ contactIndex }}"
      class="btn-icon text-primary hover:bg-turquoise-bright/25 rounded-full border-0 shadow-none m-0 size-9 shrink-0 flex justify-center items-center transition-all duration-300 lg:hidden"
      [ngClass]="{ 'pointer-events-none opacity-50': contactForm.disabled }"
      [disabled]="contactForm.disabled"
      tooltip="Edit Contact"
      (click)="editContact.emit()"
    >
      <ion-icon class="size-5" name="create-outline"></ion-icon>
    </button>
  </div>

  <div class="min-w-0">
    <label class="lg:hidden">Contact Details</label>
    <div class="flex items-center min-w-0">
      @if (showEmailUnconfirmed && originalEmail == contactForm.controls['email'].value) {
        @if (!contactForm.controls['confirmed_email'].value && contactForm.controls['email'].valid) {
          <button
            type="button"
            id="unconfirmed-email-indicator"
            class="btn-link-warning flex items-center gap-1 min-w-0 -mx-1.5 border-0 bg-none px-1 py-0 m-0 mb-1 shadow-none text-bright-orange text-left"
            tooltip="Unconfirmed email"
            tooltipAction="Click to resend confirmation"
            [attr.aria-label]="
              'Unconfirmed email for ' + contactForm.controls['email'].value + ', click to resend confirmation'
            "
            [disabled]="contactForm.disabled"
            (click)="presentResendEmailConfirmationPopover()"
          >
            <ion-icon name="warning" class="size-3.5 shrink-0"></ion-icon>
            <span class="truncate text-xs">{{ contactForm.controls['email'].value }}</span>
          </button>
        } @else {
          <span
            class="flex items-center gap-1 min-w-0 truncate text-bright-orange"
            tooltip="Unconfirmed email"
            [attr.aria-label]="'Unconfirmed email for ' + contactForm.controls['email'].value"
          >
            <ion-icon name="warning" class="size-3.5 shrink-0"></ion-icon>
            <span class="truncate">{{ contactForm.controls['email'].value }}</span>
          </span>
        }
      } @else {
        <span class="truncate">{{ contactForm.controls['email'].value }}</span>
      }
    </div>
    @if (!!contactForm.controls['telephone_number'].value) {
      <div class="text-grey-mid text-xs">
        +{{ country.attributes.dial_code }} {{ contactForm.controls['telephone_number'].value }}
      </div>
    }
    @if (!!contactForm.controls['mobile_number'].value) {
      <div class="text-grey-mid text-xs">
        +{{ country.attributes.dial_code }} {{ contactForm.controls['mobile_number'].value }}
      </div>
    }
  </div>

  <div>
    <label class="lg:hidden">Roles</label>
    <div class="flex gap-1 flex-wrap">
      @for (role of contactForm.controls['contact_roles'].value; track $index) {
        <button
          type="button"
          id="unassign-role-{{ contactIndex }}-{{ role }}"
          class="contact-role-theme bg-none shadow-none m-0 inline-flex items-center gap-1 rounded-full bg-[rgb(var(--role-rgb)/var(--role-badge-alpha))] px-2 py-1 text-[10px] font-medium text-[var(--role-color)] group/pill transition-colors hover:bg-[rgb(var(--role-rgb)/0.18)]"
          [attr.data-contact-role-color]="contactRoleDetailsByReference[role].color"
          [tooltip]="role | contactRole: groupType"
          tooltipAction="Click to unassign"
          [disabled]="contactForm.disabled"
          (click)="removeRole(role, $event)"
        >
          <span class="contact-item-role-chip-icon flex items-center justify-center size-4 rounded-full shrink-0">
            <ion-icon
              [name]="contactRoleDetailsByReference[role].icon"
              class="contact-item-role-chip-icon-default size-3.5"
            ></ion-icon>
            <ion-icon name="close" class="contact-item-role-chip-icon-hover size-3 text-bright-crimson"></ion-icon>
          </span>
          {{ role | contactRole: groupType }}
        </button>
      }
      @if (contactForm.controls['contact_roles'].value.length === 0) {
        <span class="text-grey-mid text-xs italic">No roles assigned</span>
      }
    </div>
  </div>

  <div class="hidden lg:flex items-center justify-end">
    <button
      type="button"
      id="edit-contact-{{ contactIndex }}"
      [attr.id]="'edit-contact-' + contactIndex"
      class="btn-icon text-primary hover:bg-turquoise-bright/25 rounded-full border-0 shadow-none m-0 size-9 flex-shrink-0 flex justify-center items-center transition-all duration-300"
      [ngClass]="{ 'pointer-events-none opacity-50': contactForm.disabled }"
      [disabled]="contactForm.disabled"
      tooltip="Edit Contact"
      (click)="editContact.emit()"
    >
      <ion-icon class="size-5" name="create-outline"></ion-icon>
    </button>
  </div>

  <div class="col-span-full flex flex-col gap-2 empty:hidden">
    @if (contactForm.invalid) {
      <div
        id="contact-role-error-{{ contactIndex }}"
        class="bg-gradient-to-t from-bright-crimson/25 to-50% border-b border-b-bright-crimson/40 flex justify-between md:justify-center items-center gap-2 -ml-2 -mr-2 lg:-mr-4 last:-mb-2 font-medium"
      >
        <ion-icon name="alert-circle" class="text-bright-crimson size-5 ml-2 shrink-0"></ion-icon>
        @if (contactForm.controls['contact_roles'].hasError('required')) {
          <span id="contact-role-missing-error" class="text-bright-crimson text-xs my-2">
            Assign this contact to at least one role to continue.
          </span>
        } @else {
          <span class="text-bright-crimson text-xs my-2"
            >Some fields need attention before this contact can be saved.</span
          >
        }
        @if (!contactForm.controls['contact_roles'].hasError('required')) {
          <button
            id="error-edit-contact-{{ contactIndex }}"
            class="btn-danger btn-xs m-2 shrink-0"
            [disabled]="contactForm.disabled"
            (click)="editContact.emit()"
          >
            Resolve
          </button>
        }
      </div>
    }
    @if (emailErrors[contactForm.controls['email'].value]) {
      <div
        id="contact-email-error"
        class="flex justify-between md:justify-center items-center gap-2 -ml-2 -mr-2 lg:-mr-4 last:-mb-2"
        [ngClass]="{
          'bg-gradient-to-t from-bright-orange/25 to-50% border-b border-b-bright-orange/40 font-medium': !isNotUnique,
          'bg-gradient-to-t from-bright-crimson/25 to-50% border-b border-b-bright-crimson/40 font-medium': isNotUnique,
        }"
      >
        <ion-icon
          name="warning"
          class="size-5 ml-2 shrink-0"
          [ngClass]="{
            'text-bright-orange': !contactForm.controls['email'].hasError('notUnique'),
            'text-bright-crimson': contactForm.controls['email'].hasError('notUnique'),
          }"
        ></ion-icon>
        <span
          class="text-xs my-2"
          [ngClass]="{
            'text-bright-orange': !contactForm.controls['email'].hasError('notUnique'),
            'text-bright-crimson': contactForm.controls['email'].hasError('notUnique'),
          }"
        >
          {{ emailErrors[contactForm.controls['email'].value].split('#')[0] }}
          @if (
            emailErrors[contactForm.controls['email'].value].includes('partner application #') &&
            emailErrors[contactForm.controls['email'].value].split('#')[1]
          ) {
            <a
              target="_blank"
              class="btn-link"
              tooltip="Review Partner Application"
              [routerLink]="
                '/partner-applications/edit/' + emailErrors[contactForm.controls['email'].value].split('#')[1]
              "
            >
              #{{ emailErrors[contactForm.controls['email'].value].split('#')[1] }}
            </a>
          }
          @if (
            emailErrors[contactForm.controls['email'].value].includes('partner #') &&
            emailErrors[contactForm.controls['email'].value].split('#')[1]
          ) {
            <a
              target="_blank"
              class="btn-link"
              tooltip="Edit Customer"
              [routerLink]="'/customers/edit/' + emailErrors[contactForm.controls['email'].value].split('#')[1]"
            >
              #{{ emailErrors[contactForm.controls['email'].value].split('#')[1] }}
            </a>
          }
        </span>
      </div>
    }
  </div>
</div>
